import { userSchema } from '../models';

export const get = (userId: string) => {
  return {
    endpoint: `/users/${userId}`,
    method: 'GET',
    responseSchema: userSchema,
  } as const;
};
